import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getPackageConfig,
  getPickerMode,
} from '../../redux/packagePicker/selectors';
import {
  getPackagePickerConfigOrder,
  getRecommendedPackageType,
} from './utils';
import { CoreTypes } from './types';

export const usePackagePickerOrder = (): CoreTypes[] => {
  const packageConfig = useSelector(getPackageConfig);
  const pickerMode = useSelector(getPickerMode);
  const packagePickerOrder = getPackagePickerConfigOrder(
    packageConfig,
    pickerMode
  );
  return packagePickerOrder;
};

export const useRecommendedPackageIndex = (): number => {
  const packageConfig = useSelector(getPackageConfig);
  const packagePickerOrder = usePackagePickerOrder();

  const recommendedPackageIndex = useMemo(() => {
    const recommendedPackageType = getRecommendedPackageType(packageConfig);
    return packagePickerOrder.findIndex(
      coreType => coreType === recommendedPackageType
    );
  }, [packageConfig, packagePickerOrder]);

  return recommendedPackageIndex;
};

export const useRecommendedPackage = (): CoreTypes | undefined => {
  const packagePickerOrder = usePackagePickerOrder();
  const recommendedPackageIndex = useRecommendedPackageIndex();

  return packagePickerOrder?.[recommendedPackageIndex];
};
